var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 34,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4743 24.6223C19.0028 24.6223 22.6738 20.4752 22.6738 15.3595C22.6738 10.2438 19.0028 6.0968 14.4743 6.0968C9.94588 6.0968 6.27483 10.2438 6.27483 15.3595C6.27483 20.4752 9.94588 24.6223 14.4743 24.6223Z",
    stroke: "#FFFFEF",
    strokeWidth: 4.10845
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35254 1.9659C3.84428 2.77468 6.16812 4.65127 7.96855 7.30851",
    stroke: "#FFFFEF",
    strokeWidth: 4.10845
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1136 10.3609C25.0133 8.36789 27.6358 7.08866 30.5798 6.71895",
    stroke: "#FFFFEF",
    strokeWidth: 4.10845
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08601 32.2131C5.32559 31.3744 4.75699 30.3966 4.41581 29.3409C4.07462 28.2852 3.96826 27.1743 4.10336 26.078C4.23845 24.9816 4.61208 23.9234 5.2009 22.9697C5.78964 22.016 6.58092 21.1874 7.52496 20.5358",
    stroke: "#FFFFEF",
    strokeWidth: 4.10845
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.911eba0c86625f32cc76cfb10cda6400.svg";
export { ForwardRef as ReactComponent };